export const CONJOINT_TEXT_MAX_LENGTH = 200;

export const CONJOINT_ATTRIBUTE_TYPES = {
  FEATURE: 'Feature',
  BRAND: 'Brand',
  PRICE: 'Price',
};

export const COLLAPSE_OPEN_KEY = 'attribute-collapse';

export const CONJOINT_MIN_ATTRIBUTES = 2;
export const CONJOINT_MIN_ATTRIBUTE_VALUES = 2;
export const MAXDIFF_MIN_ATTRIBUTES = 1;

export const ERRORS_BLOCKING_DOE = [
  'emptyAttributeValues',
  'exceededMaxAttributeValues',
  'mixedPositiveWithNegativePriceValues',
  'sameAttributePriceValues',
];

export const CONJOINT_DOE_STRICT_CONSTRAINTS_ERROR =
  'Cannot create design. Constraints are too strict.';
